var React = require('react');

function Jp (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("clipPath",{"id":"a"},React.createElement("path",{"fillOpacity":".7","d":"M-88 32h640v480H-88z"}))),React.createElement("g",{"fillRule":"evenodd","strokeWidth":"1pt","clipPath":"url(#a)","transform":"translate(88 -32)","key":1},[React.createElement("path",{"fill":"#fff","d":"M-128 32h720v480h-720z","key":0}),React.createElement("ellipse",{"cx":"523.1","cy":"344.1","fill":"#d30000","rx":"194.9","ry":"194.9","transform":"translate(-168.4 8.6) scale(.76554)","key":1})])]);
}

Jp.defaultProps = {"viewBox":"0 0 640 480"};

module.exports = Jp;

Jp.default = Jp;
